import { useEffect, useRef } from "react";

function SolidCheckbox({
  checked = false,
  indeterminate = false,
  onChange,
  disabled = false,
  style: {
    height = "20px",
    width = "20px",
    display = 'block',
    margin = 0,
    padding = 0,
    ...style
  } = {},
  ...props
}) {

  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = Boolean(indeterminate);
    }
  }, [indeterminate]);

  const baseStyle = {
    cursor: disabled ? 'not-allowed' : 'pointer',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    border: '1px solid #ABABAB',
    borderRadius: '3px',
    backgroundColor: checked ? '#121212' : '#fff',
    opacity: disabled ? 0.5 : 1,
    height,
    width,
    maxWidth: width,
    maxHeight: height,
    minWidth: width,
    minHeight: height,
    margin,
    padding,
    ...style
  };

  return (
    <input
      ref={inputRef}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      style={baseStyle}
      {...props}
    />
  )
}

export default SolidCheckbox